export const allowedRolesMap: Record<string, string[]> = {
  // Sistem Ayarları & Güvenlik
  '/site-ayarlari': ['super_admin'],
  '/dil-ayarlari': ['super_admin'],
  '/kullanicilar': ['super_admin', 'admin'],

  // Genel Yönetim Modülleri (Tüm Yetkiler)
  '/kategoriler': ['super_admin', 'admin', 'editor'],
  '/urunler': ['super_admin', 'admin', 'editor'],
  '/hero-slider': ['super_admin', 'admin', 'editor'],
  '/hakkimizda': ['super_admin', 'admin', 'editor'],
  '/sektorler': ['super_admin', 'admin', 'editor'],
  '/uretim-sureci': ['super_admin', 'admin', 'editor'],
  '/ekip': ['super_admin', 'admin', 'editor'],
  '/sertifikalar': ['super_admin', 'admin', 'editor'],
  '/sss': ['super_admin', 'admin', 'editor'],
  '/iletisim-mesajlari': ['super_admin', 'admin', 'editor'],
  '/is-ilanlari': ['super_admin', 'admin', 'editor'],
  '/basvurular': ['super_admin', 'admin', 'editor'],

  // Yeni Eklenen Modüller
  '/blog': ['super_admin', 'admin', 'editor'],
  '/referanslar': ['super_admin', 'admin', 'editor'],
  '/sayfalar': ['super_admin', 'admin', 'editor'],
  '/muhendislik': ['super_admin', 'admin', 'editor'],
  '/global-harita': ['super_admin', 'admin', 'editor'],
}